import { CLIENT } from '../constant/actionTypes';

const getClientSoftwareSubmodules = (state, action) => {
  switch (action.type) {
    case CLIENT.SOFTWARE_SUBMODULES.INITIATE:
      return { isFetching: true };
    case CLIENT.SOFTWARE_SUBMODULES.SUCCESS:
      return {
        isFetching: false,
        data: action.payload,
      };
    case CLIENT.SOFTWARE_SUBMODULES.ERROR:
      return {
        isFetching: false,
        data: action.payload,
      };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getClientSoftwareSubmodules;
